import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import './App.css';
import theme from 'theme/mui';
import UnAuthenticated from 'components/UnAuthenticated';
import Authenticated from 'components/Authenticated';
import useUser from 'hooks/useUser/userContext';
import { NotificationProvider } from 'hooks/useNotification/useNotification';
import WunaLoader from './components/common/WunaLoader/WunaLoader';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { useNavigate, matchPath, useLocation } from 'react-router-dom';
import { getAuthorization, setReturnUrl } from 'utils/authCookie';
import Endpoints from 'constant/endpoints';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import PermissionProvider from 'components/PermissionProvider/permissionProvider';
import { fetchPermission } from 'services/permissionsService';
import ErrorCodesFromApi from 'constant/errorCodesFromApi';

function App() {
  const UNAUTHORIZED = 401;
  const { user, userLoading, logoutUnAuthorised } = useUser();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const location = useLocation();

  if (
    !user &&
    (matchPath(
      {
        path: Endpoints.QR_DETAILS_BY_ID,
      },
      location?.pathname ?? '',
    ) ||
      matchPath(
        {
          path: Endpoints.CONFIRM_VERIFIER_ROLE,
        },
        location?.pathname ?? '',
      ))
  ) {
    setReturnUrl(location.pathname);
  }

  React.useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response) {
          const { status, data } = error.response;
          if (status === UNAUTHORIZED) {
            if (
              !matchPath(
                {
                  path: Endpoints.LOGIN,
                },
                location?.pathname ?? '',
              ) &&
              !matchPath(
                {
                  path: Endpoints.LOGIN2STEP,
                },
                location?.pathname ?? '',
              )
            ) {
              logoutUnAuthorised();
              navigate(Endpoints.LOGIN);
            }
          } else if (
            data?.code === ErrorCodesFromApi.ACCOUNT_PAUSED &&
            getAuthorization()
          ) {
            logoutUnAuthorised();
            navigate(Endpoints.LOGIN);
            enqueueSnackbar(data.message, {
              variant: 'error',
              preventDuplicate: true,
            });
          } else if (data?.code === ErrorCodesFromApi.ACCESS_DENIED) {
            navigate(Endpoints.ACCEESS_DENIED);
          }
        }
        return Promise.reject(error);
      },
    );
    return () => axios.interceptors.response.eject(interceptor);
  }, [location?.pathname, logoutUnAuthorised, navigate, enqueueSnackbar]);

  if (userLoading) {
    return <WunaLoader />;
  }
  return (
    <ThemeProvider theme={theme}>
      <NotificationProvider>
        <PermissionProvider fetchPermission={fetchPermission(user)}>
          {user && !user.user2fa ? <Authenticated /> : <UnAuthenticated />}
        </PermissionProvider>
      </NotificationProvider>
    </ThemeProvider>
  );
}

export default App;
